<footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-muted mb-1 mb-md-0">Derechos de autor © 2023 <a href="https://elfogonchicken.com/" target="_blank">El Fogón Chicken</a>.</p>
  <p class="text-muted">Hecho a mano con <i class="feather icon-heart mb-1 text-primary ms-1 icon-sm"></i></p>
</footer>